import React from "react"
import types from "prop-types"
import { taskShape } from "utils/propTypeShapes"
import SubformSection from "Forms/FormElements/SubformElements/SubformSection"
import TaskDeletedQuestionAnswers from "./TaskDeletedQuestionAnswers"

const TaskOpenTaskForm = ({ task, taskControls }) => {
  const { subform } = task
  const { sections } = subform

  return (
    <>
      {
        sections?.map((section, sectionIndex) => (
          <SubformSection
            key={section.uuid}
            className="mb-6"
            isFirstSection={sectionIndex === 0}
            section={section}
            task={task}
          />
        ))
      }
      {
        taskControls && (
          <>{taskControls}</>
        )
      }
      <TaskDeletedQuestionAnswers task={task} />
    </>
  )
}

TaskOpenTaskForm.propTypes = {
  task: taskShape.isRequired,
  taskControls: types.node.isRequired,
}

export default TaskOpenTaskForm
